import React, { Component } from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table
} from "reactstrap";

import { Link } from "react-router-dom";
// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import { LocalDataSetup } from '../pouchDB/LocalDataSetup';
// import { MasterSync } from "MasterSync";

class Dashboard extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            recentJobs:  [],
            outstandingJobs: 0,
            onSiteJobs: 0,
            documentsRequired: 0,
            windowWidth: window.innerWidth
        };
    }

    async componentDidMount() {
        this.getRecentJobs().then(recentJobs => {
            // console.log(recentJobs)
            this.setState({recentJobs: recentJobs})
        })
        this.getOutstandingJobs().then(outstandingJobs => {
            // console.log(recentJobs)
            this.setState({outstandingJobs: outstandingJobs})
        })
        this.getOnSiteJobs().then(onSiteJobs => {
            this.setState({onSiteJobs: onSiteJobs})
        })
        this.getDocumentsRequired().then(documentsRequired => {
            // console.log(recentJobs)
            this.setState({documentsRequired: documentsRequired})
        })

        window.addEventListener('resize', this.handleResize)

        // MasterSync(sessionStorage.getItem('subcon_id'));
    }

    handleResize = () => {
        this.setState({windowWidth: window.innerWidth})
    }

	async getDocumentsRequired() {
		let documentsRequired = 0;
		let db_jobs_local = LocalDataSetup.db_jobs_local

		await db_jobs_local.allDocs({
			include_docs: true,
			attachments: true
		}).then(result => {
			result.rows.filter(row => {
                let subcon_ids = sessionStorage.getItem('subcon_id');
                subcon_ids = subcon_ids.split(',');

                if(subcon_ids.includes(row.doc.job.UserRef1JobSessionID)){
                    return row; // Filter for jobs that belong to the subcontractor
                }
                else {
                    return null;
                }
            })
            .forEach(row => {
				if (parseInt(row.doc.job.Status) > 400 && row.doc.job.Attachments.length === 0) {
					documentsRequired++;
				}
			});
		}
		).catch(err => {
			console.log(err);
		}
		);

		return documentsRequired;
	}

	async getOnSiteJobs() {
		let onSiteJobs = 0;
		let db_jobs_local = LocalDataSetup.db_jobs_local

		await db_jobs_local.allDocs({
			include_docs: true,
			attachments: true
		}).then(result => {
			result.rows.filter(row => {
                let subcon_ids = sessionStorage.getItem('subcon_id');
                subcon_ids = subcon_ids.split(',');

                if(subcon_ids.includes(row.doc.job.UserRef1JobSessionID)){
                    return row; // Filter for jobs that belong to the subcontractor
                }
                else {
                    return null;
                }
            })
            .forEach(row => {
				if (parseInt(row.doc.job.Status) === 400) {
					onSiteJobs++;
				}
			});
		}
		).catch(err => {
			console.log(err);
		}
		);

		return onSiteJobs;
	}

	async getOutstandingJobs() {
		let outstandingJobs = 0;
		let db_jobs_local = LocalDataSetup.db_jobs_local

		await db_jobs_local.allDocs({
			include_docs: true,
			attachments: true
		}).then(result => {
			result.rows.filter(row => {
                let subcon_ids = sessionStorage.getItem('subcon_id');
                subcon_ids = subcon_ids.split(',');

                if(subcon_ids.includes(row.doc.job.UserRef1JobSessionID)){
                    return row; // Filter for jobs that belong to the subcontractor
                }
                else {
                    return null;
                }
            })
            .forEach(row => {
				if (parseInt(row.doc.job.Status) < 400) {
					// console.log(row)
					outstandingJobs++;
				}
			});
		}).catch(err => {
			console.log(err);
		});

		console.log(outstandingJobs)

		return outstandingJobs;
	}

    async getRecentJobs() {
        let recentJobs = [];
        let db_jobs_local = LocalDataSetup.db_jobs_local
      
        // get all jobs from local db and filter for jobs within the last 7 days and add the 10 most recent to the recentJobs array
        db_jobs_local.allDocs({
        	include_docs: true,
          	attachments: true
        }).then(result => {
         	result.rows.filter(row => {
                let subcon_ids = sessionStorage.getItem('subcon_id');
                subcon_ids = subcon_ids.split(',');

                if(subcon_ids.includes(row.doc.job.UserRef1JobSessionID)){
                    return row; // Filter for jobs that belong to the subcontractor
                }
                else {
                    return null;
                }
            })
            .forEach(row => {
				const visitDate = new Date(row.doc.job.VisitDate); // Step 1: Parse VisitDate
				const currentDate = new Date(); // Step 2: Get current date
				const oneDay = 24 * 60 * 60 * 1000; // Milliseconds in one day
		
				// Step 3: Calculate the difference in days
				const differenceInDays = Math.round((currentDate - visitDate) / oneDay);
		
				// Step 4: Check if the difference is within the last 7 days
				if (differenceInDays <= 7 && row.doc.job.Status < 600) {
				recentJobs.push(row.doc.job); // Add to recentJobs if within the last 7 days
				}
		
          	});
        }).catch(err => {
          console.log(err);
        });
      
        return recentJobs;
    }

    render() {
        return (
        <>
            <PanelHeader
                size="lg"
                content={image}
            />
            <div className="content" style={{marginTop: '-40px'}}>
                <Row>
                <Col xs={12} md={12}>
                    <Card className="card-stats card-raised">
                    <CardBody>
                        <Row>
                        <Col md="4">
                            <div className="statistics">
                            <Link to={`/admin/jobsearch/${'outstanding'}/${'none'}`}>
                            <div className="info">
                                <div className="icon icon-danger">
                                <i className="now-ui-icons business_bulb-63" />
                                </div>
                                <h3 className="info-title">{this.state.outstandingJobs}</h3>
                                <h6 className="stats-title">Outstanding</h6>
                            </div>
                            </Link>
                            </div>
                        </Col>
                        <Col md="4">
                            <div className="statistics">
                            <Link to={`/admin/jobsearch/${'onsite'}/${'none'}`}>
                            <div className="info">
                                <div className="icon icon-success">
                                <i className="now-ui-icons location_pin" />
                                </div>
                                <h3 className="info-title">
                                {this.state.onSiteJobs}
                                </h3>
                                <h6 className="stats-title">On Site</h6>
                            </div>
                            </Link>
                            </div>
                        </Col>
                        <Col md="4">
                            <div className="statistics">
                            <Link to={`/admin/jobsearch/${'docsrequired'}/${'none'}`}>
                            <div className="info">
                                <div className="icon icon-info">
                                <i className="now-ui-icons files_single-copy-04" />
                                </div>
                                <h3 className="info-title">{this.state.documentsRequired}</h3>
                                <h6 className="stats-title">Documents Required</h6>
                            </div>
                            </Link>
                            </div>
                        </Col>
                        </Row>
                    </CardBody>
                    <CardFooter>
                        <div className="stats float-right">
                        <i className="now-ui-icons arrows-1_refresh-69" onClick={() => this.componentDidMount()} />
                        </div>
                        <br/>
                    </CardFooter>
                    </Card>
                </Col>
                </Row>
                <Row>
                <Col xs={12} md={12}>
                    <Card  style={{overflow: 'auto'}}>
                    <CardHeader>
                        <CardTitle tag="h4" className="card-category">Upcoming Jobs</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <Table style={{overflow: 'auto'}}>
                            <thead className="jcwMainColour">
                                <tr>
									<th>Status</th>
									<th>Purchase Order</th>
									<th>Job No.</th>
									<th>Job Type</th>
                                    <th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Site</th>
									<th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Address</th>
									<th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Job Details</th>
									<th style={this.state.windowWidth < 880 ? {display: 'none'} : {display: ''}}>Visit Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                // order the recentJobs array by VisitDate and show most recent 10
								this.state.recentJobs && this.state.recentJobs
                                .sort((a, b) => {
                                    //sort by VisitDate descending
                                    return new Date(a.VisitDate) - new Date(b.VisitDate);
                                })
                                .filter((job, index) => {
                                    return job.Status < 800;
                                })
                                .filter((job, index) => index < 10)
                                .map((job, index) => {
                                    if(this.state.windowWidth < 880) {
                                        return (
                                            <>
                                            <Link key={index} className={"table-row "} to={`/admin/jobsearch/${'none'}/${job.JobID+'*'+job.SessionID}`}>
                                                <td>{job.StatusDesc}</td>
                                                <td>{job.PurchaseOrder}</td>
                                                <td>{job.JobID}</td>
                                                <td>{job.JobType}</td>
                                            </Link>
                                            <Link key={index} className={"table-row "} to={`/admin/jobsearch/${'none'}/${job.JobID+'*'+job.SessionID}`}>
                                                <td colSpan={2}>{job.Name}</td>
                                                <td colSpan={2}>{job.Address}</td>
                                            </Link>
                                            <Link style={{borderBottom: '2px solid #4a4a4a'}} key={index} className={"table-row "} to={`/admin/jobsearch/${'none'}/${job.JobID+'*'+job.SessionID}`}>
                                                <td colSpan={3}>Job Details: {job.ToDo.substring(0, 50)}</td>
                                                <td>Visit Date: {
                                                    new Date(job.VisitDate).toLocaleDateString("en-GB", {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit"
                                                    })}
                                                </td>
                                            </Link>
                                            </>
                                        );
                                    }
                                    else {
                                        return (
                                            <Link key={index} className="table-row" to={`/admin/jobsearch/${'none'}/${job.JobID+'*'+job.SessionID}`}>
                                                <td>{job.StatusDesc}</td>
                                                <td>{job.PurchaseOrder}</td>
                                                <td>{job.JobID}</td>
                                                <td>{job.JobType}</td>
                                                <td>{job.Name}</td>
                                                <td>{job.Address}</td>
                                                <td>{job.ToDo}</td>
                                                <td>{
                                                    new Date(job.VisitDate).toLocaleDateString("en-GB", {
                                                        year: "numeric",
                                                        month: "2-digit",
                                                        day: "2-digit"
                                                    })}
                                                </td>
                                            </Link>
                                        );
                                    }
                                })
                                }
                            </tbody>
                        </Table>
                    </CardBody>
                    <CardFooter>
                        <div className="stats float-right">
                        <i className="now-ui-icons arrows-1_refresh-69" 
						onClick={() => this.componentDidMount()}
                        />
                        </div>
                        <br/>
                    </CardFooter>
                    </Card>
                </Col>
                </Row>
                
            </div>

        </>
        )

    }
}

export default Dashboard;